import React, { Component } from 'react';
import { Table, Button, Form, Input, Select, Tabs, Checkbox, Tooltip, message, Spin } from 'antd'
import moment from 'moment'
import './review.scss'
import { getQualityControl, getHospitalList, getConsultationApplyHospital, qualified, getExamImageApp } from '@/request/api'
import UnqualifiedModal from './unqualifiedMoadl'
import { requestErrorLog } from "@/common/util";

const { Option } = Select;
const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;
class Review extends Component { // 质控管理
  state = {
    tableData: [],
    currentIndex: 1,
    applyHospitalList: [],
    consultHospitalList: [],
    inspectionType: [],
    checkType: [],
    rowData: {},
    tabKey: "caseList",
    PageNo: 1,
    PageSize: 10,
    RowCount: 0,
    loading: true,
    inspectType: [
      { label: '静息心电', value: "ECG" },
      { label: '动态心电', value: "Holter" },
      { label: '动态血压', value: "BloodPressure" },
    ],
  }
  commonColumn = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
      width: 70,
      render: (text, record, index) => {  //生成序号
        return (
          <span>{(this.state.currentIndex - 1) * 10 + (index + 1)}</span>
        )
      },
    },
    {
      title: '质控结果',
      dataIndex: 'QUALITY_RESULTS',
      key: 'QUALITY_RESULTS',
      align: 'center',
      width: 120,
      ellipsis: true,
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <span>{text}</span>
          </Tooltip>
        )
      }
    },
    {
      title: '质控日志',
      dataIndex: 'QUALITY_LOG',
      key: 'QUALITY_LOG',
      align: 'center',
      width: 120,
      ellipsis: true,
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <span>{text}</span>
          </Tooltip>
        )
      }
    },
    {
      title: '姓名',
      dataIndex: 'NAME',
      key: 'NAME',
      align: 'center',
      width: 120,
      ellipsis: true,
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <span>{text}</span>
          </Tooltip>
        )
      }
    },
    {
      title: '性别',
      dataIndex: 'SEX_NAME',
      key: 'SEX_NAME',
      width: 70,
    },
    {
      title: '年龄',
      dataIndex: 'AgeDisPlay',
      key: 'AgeDisPlay',
      width: 70
    },
    {
      title: "申请医院",
      dataIndex: "APPLY_HOSPITAL_NAME",
      key: "APPLY_HOSPITAL_NAME",
      align: 'center',
      width: 140
    },
    {
      title: "最终会诊医院",
      dataIndex: "CONSULTATION_HOSPITAL_NAME",
      key: "CONSULTATION_HOSPITAL_NAME",
      align: 'center',
      width: 140
    },
    {
      title: "会诊人",
      dataIndex: "CONSULTATION_DOCTOR_NAME",
      key: "CONSULTATION_DOCTOR_NAME",
      align: 'center',
      width: 120
    },
    {
      title: "完成会诊时间",
      dataIndex: "CONSULTATION_DATE",
      key: "CONSULTATION_DATE",
      align: 'center',
      width: 160,
      sorter: (a, b) => new Date(a.CONSULTATION_DATE).getTime() - new Date(b.CONSULTATION_DATE).getTime(),
      render: (val) => (
        <span>
          {val && moment(val).format("YYYY-MM-DD HH:mm:ss")}
        </span>
      ),
    },
    {
      title: "检查项目",
      dataIndex: "ITEM_NAME",
      key: "ITEM_NAME",
      align: 'center',
      width: 120,
    },
    {
      title: '检查结论',
      dataIndex: 'CONCLUSIONS',
      key: 'CONCLUSIONS',
      ellipsis: true,
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <span>{text}</span>
          </Tooltip>
        )
      }
    }
  ];

  componentDidMount() {
    this.initConsultHospitalList()
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const statisticalType = localStorage.getItem('statisticalType')

    this.setState({
      consultHospitalCode: userInfo.HOSPITAL_CODE === 'PLATFORM' || statisticalType === '监管机构' ? '' : userInfo.HOSPITAL_CODE,
      consultHospitalName: userInfo.HOSPITAL_NAME === '平台管理' || statisticalType === '监管机构' ? '' : userInfo.HOSPITAL_NAME,
    }, () => {
      this.initApplyHostpitalList(userInfo.HOSPITAL_CODE)
      this.handleHospitalSubmit()
    })
  }

  //每次切换页码的时候,更新之前初始化的页码
  onChangePage = {
    onChange: (page, pageSize) => {
      this.setState({
        currentIndex: page
      })
    }
  }

  //申请医院列表
  initApplyHostpitalList = (val) => {
    getConsultationApplyHospital(val).then(res => {
      if (res && res.Status === 1) {
        this.setState({
          applyHospitalList: res.Result
        })
      } else {
        requestErrorLog('', '质量控制申请机构列表接口报错', 0, true)
      }
    })
  }

  // 会诊医院列表
  initConsultHospitalList = () => {
    getHospitalList().then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          consultHospitalList: res.Result.CONSULATION_HOSPITAL
        })
      } else {
        requestErrorLog('', '质量控制会诊机构列表接口报错', 0, true)
      }
    })
  }

  handleHospitalSubmit = () => {
    const { consultHospitalCode, PageNo, PageSize, tabKey } = this.state
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let params = {
          Type: "QualityControlList",
          PageNo: PageNo,
          PageSize: PageSize,
          HOSPITAL_CODE: consultHospitalCode,                               // 会诊医院
          NAME: values.NAME,                                                // 姓名
          APPLY_HOSPITAL_CODE: values.APPLY_HOSPITAL_CODE || "",            // 申请医院
          EXAM_CLASS: values.EXAM_CLASS,                                    // 检查类型
          ISQUALIFIED: tabKey === "eligibleCases" ? 1 : tabKey === "unqualifiedCases" ? 0 : "",        //是否合格(1：合格，0：不合格)
        }
        getQualityControl(params).then((res) => {
          if (res && res.Status === 1) {
            this.setState({
              tableData: res.Result.dataInfo,
              RowCount: res.Result.pageInfo.RowCount,
              loading: false
            })
          } else {
            requestErrorLog('', '质量控制列表接口报错', 0, true)
          }
        })
      }
    })
  }

  // 会诊机构
  consultHospitalChange = (val) => {
    this.setState({
      consultHospitalCode: val,
    })
    this.props.form.setFieldsValue({
      HOSPITAL_CODE: ""
    });
    this.initApplyHostpitalList(val)
  }

  handleActiveKey = (key) => {
    this.setState({
      tabKey: key,
      PageNo: 1,
      PageSize: 10,
      loading: true
    }, () => {
      this.handleHospitalSubmit()
    })
  }

  // 点击不合格
  handleUnqualified = () => {
    const { tabKey, rowData } = this.state
    if (rowData.EXAM_UID) {
      if (tabKey === "eligibleCases") {
        message.warning("请先点击撤销再执行此操作")
      } else {
        this.setState({
          unqualifieVisible: true,
        })
      }
    } else {
      message.info("请在列表中选择一条要操作的数据")
    }
  }

  // 点击合格与撤销
  handleQualified = (type) => {
    const { rowData, tabKey } = this.state
    if (rowData.EXAM_UID) {
      if (type === "qualified" && tabKey === "unqualifiedCases") {
        message.warning("请先点击撤销再执行此操作")
      } else {
        let requestModel = {
          ISQUALIFIED: type === "qualified" ? 1 : "", // 合格
          QUALITY_UID: rowData.QUALITY_UID
        }
        qualified(requestModel).then((res) => {
          if (res && res.Status === 1) {
            message.success("操作成功")
            this.handleHospitalSubmit()
            this.setState({
              rowData: ""
            })
          } else {
            requestErrorLog('', '质量控制合格/撤销接口报错', 0, true)
            message.error("操作失败")
          }
        })
      }
    } else {
      message.info("请在列表中选择一条要操作的数据")
    }
  }

  onClickRow = (record) => { // 单击行
    this.setState({
      rowData: record
    })
  }

  // 双击查看报告
  handleDoubleClicks = (record) => {
    let params = {
      Type: "ExamImageApp", // 检查项目诊断图像
      EXAM_UID: record.EXAM_UID
    }
    getExamImageApp(params).then((res) => {
      if (res && res.Status === 1) {
        if (res.Result === -2) {
          message.error("报告文件打开失败")
          return
        }
        const images = window.g.baseURL + "/" + res.Result
        window.open(images)
      } else {
        requestErrorLog('', '质量控制打开PDF接口报错', 0, true)
        message.error('请求失败')
      }
    })
  }

  setRowClassName = (record) => {
    return record === this.state.rowData ? 'clickRowStyl' : '';
  }

  onChangePage = (page, pageSize) => {  //页码改变
    this.setState({
      PageNo: page,
    }, () => {
      this.handleHospitalSubmit()
    })
  }

  searchListFn = () => { // 查询重置页码
    this.setState({
      PageNo: 1,
      PageSize: 10
    }, () => {
      this.handleHospitalSubmit()
    })
  }

  handleChangeReset = () => { //重置
    this.props.form.resetFields();
  }

  getReviewList(data) {
    return (
      <>
        <Spin spinning={this.state.loading} size="large" tip="Loading...">
          <Table
            style={{ marginTop: '20px' }}
            columns={this.commonColumn}
            dataSource={data}
            rowKey={record => record.EXAM_UID}					// 需要修改为唯一的ID！
            pagination={{ //分页
              total: this.state.RowCount,
              current: this.state.PageNo,
              onChange: this.onChangePage
            }}
            onRow={record => {
              return {
                onClick: e => { this.onClickRow(record) }, //点击行
                onDoubleClick: e => { this.handleDoubleClicks(record) },//双击行
              }
            }}
            rowClassName={this.setRowClassName}
          />
        </Spin>
      </>
    )
  }
  render() {
    const { tableData, applyHospitalList, consultHospitalList, consultHospitalName, unqualifieVisible, rowData } = this.state
    const { form: { getFieldDecorator } } = this.props
    const statisticalType = localStorage.getItem('statisticalType');
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}

    return (
      <>
        <div className="review_wrap">
          <div className="wraplist" onClick={() => this.handleQualified("qualified")}>
            <img alt="" src={require("@/assets/image/hege1.png").default} />
            <p >合格</p>
          </div>
          <div className="wraplist" onClick={this.handleUnqualified}>
            <img alt="" src={require("@/assets/image/buhege1.png").default} />
            <p>不合格</p>
          </div>
          {
            this.state.tabKey !== "caseList" ?
              <div className="wraplist" onClick={() => this.handleQualified("revoke")} >
                <img alt="" src={require("@/assets/image/chexiao_1.png").default} />
                <p>撤销</p>
              </div>
              : null
          }
        </div>

        {
          unqualifieVisible ?
            <UnqualifiedModal
              visible={unqualifieVisible}
              rowData={rowData}
              refTabKey={this.state.refTabKey}
              handleHospitalSubmit={this.handleHospitalSubmit}
              onRef={(ref) => {
                this.setState({ unqualifieVisible: ref })
              }}
            /> : null
        }

        <Form layout="inline" className="commonReview">
          <Form.Item label="患者姓名">
            {getFieldDecorator("NAME", { initialValue: "" })(<Input />)}
          </Form.Item>

          <Form.Item label="会诊机构">
            {getFieldDecorator('HOSPITAL_CODE', { initialValue: consultHospitalName })(
              statisticalType === "监管机构" || userInfo.IS_ADMINISTRATOR === "1" ?
                <Select style={{ width: "200px" }} onChange={this.consultHospitalChange}>
                  <Option value="">全部</Option>
                  {consultHospitalList.map(item => (
                    <Option key={item.HOSPITAL_CODE} value={item.HOSPITAL_CODE}>
                      {item.HOSPITAL_NAME}
                    </Option>
                  ))}
                </Select>
                : <Input disabled />
            )}
          </Form.Item>

          <Form.Item label="申请机构">
            {getFieldDecorator('APPLY_HOSPITAL_CODE', { initialValue: "" })(
              <Select style={{ width: "200px" }}>
                <Option value="">全部</Option>
                {applyHospitalList.map(item => (
                  <Option key={item.APPLY_HOSPITAL_CODE} value={item.APPLY_HOSPITAL_CODE}>
                    {item.APPLY_HOSPITAL_NAME}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>

          <Form.Item label="检查类型">
            {getFieldDecorator("EXAM_CLASS", { initialValue: [] })(
              <CheckboxGroup
                options={this.state.inspectType}
              >
              </CheckboxGroup>
            )}
          </Form.Item>

          <Button style={{ marginRight: '10px', marginTop: '5px' }} onClick={() => this.searchListFn()}>查询</Button>
          <Button onClick={() => this.handleChangeReset()}>重置</Button>
        </Form>

        <Tabs type="card" className="tabWrap eleWrap" onChange={this.handleActiveKey}>
          <TabPane tab="病例列表" key="caseList">
            {this.getReviewList(tableData)}
          </TabPane>
          <TabPane tab="合格病例" key="eligibleCases">
            {this.getReviewList(tableData)}
          </TabPane>
          <TabPane tab="不合格病例" key="unqualifiedCases">
            {this.getReviewList(tableData)}
          </TabPane>
        </Tabs>
      </>
    );
  }
}

export default Form.create({})(Review);